import { Sync, Done, ModelTraining } from "@mui/icons-material";
import MDTypography from "components/Basics/MDTypography";
import FaiqActionButton from "./FaiqActionButton";
import { t } from "i18next";

/**
 * Display help information for FAIQ integration actions.
 * This component provides a table with descriptions of various FAIQ actions.
 * @returns {JSX.Element} The rendered component.
 */
const FaiqIntegrationHelp = () => {
	return (
		<table
			style={{
				borderCollapse: "separate",
				borderSpacing: "3em 3em"
			}}
		>
			{/*  */}
			<tr>
				<td>
					<FaiqActionButton
						color="info"
						text={t("FAIQ.ACTIONS.learnToFaiq")}
						icon={<ModelTraining fontSize="small" />}
					/>
				</td>
				<td>
					<MDTypography variant="body2">{t("FAIQ.HELP.learnToFaiqDescription")}</MDTypography>
				</td>
			</tr>
			{/*  */}
			<tr>
				<td>
					<FaiqActionButton
						color="success"
						text={t("SETTINGS.available")}
						icon={<Done fontSize="small" />}
					/>
				</td>
				<td>
					<MDTypography variant="body2">{t("FAIQ.HELP.availableDescription")}</MDTypography>
				</td>
			</tr>
			{/*  */}
			<tr>
				<td>
					<FaiqActionButton
						color="warning"
						text={t("SETTINGS.upgrade")}
						icon={<Sync fontSize="small" />}
					/>
				</td>
				<td>
					<MDTypography variant="body2">{t("FAIQ.HELP.upgradeDescription")}</MDTypography>
				</td>
			</tr>
		</table>
	);
};

export default FaiqIntegrationHelp;
